import {
  BMI_27_CHECK,
  DIABETIC_TYPE_1,
  DIETING,
  GALLBLADDER,
  MEDICATIONS,
  OPIOID,
  PANCREATITIS,
  PANCREATITIS_BRANCH_END,
  PANCREATITIS_GALLBLADDER,
  PHQ1,
  PHQ2,
  SHOW_IF_BMI_BETWEEN_27_AND_30,
  SHOW_IF_BMI_LESS_27,
  SHOW_IF_BMI_MORE_30,
  SUICIDE1
} from "config/tags";
import { HIGH_BMI, OBESE_BMI } from "utils/eligibility";
import {
  findAnswerByQuestionTag,
  findAnswerByTagAndByQuestionTag
} from "utils/questions";

export const oldClinicalRouting = ({
  nextUrlPath: nextUrlPathInit,
  question,
  answers,
  assessment,
  routes,
  profile
}) => {
  let nextUrlPath = nextUrlPathInit;

  // Routing for showing pancreatitis and gallbladder questions.
  if (question.tags.includes(PANCREATITIS_GALLBLADDER)) {
    const pancreatitisAnswer = findAnswerByTagAndByQuestionTag(
      PANCREATITIS,
      PANCREATITIS_GALLBLADDER,
      answers,
      assessment.questions
    );
    const gallbladderAnswer = findAnswerByTagAndByQuestionTag(
      GALLBLADDER,
      PANCREATITIS_GALLBLADDER,
      answers,
      assessment.questions
    );

    if (pancreatitisAnswer) {
      nextUrlPath = routes.question(
        assessment.questions.find(
          q => q._id === pancreatitisAnswer.nextQuestionId
        ).urlPath
      );
    } else if (gallbladderAnswer) {
      nextUrlPath = routes.question(
        assessment.questions.find(
          q => q._id === gallbladderAnswer.nextQuestionId
        ).urlPath
      );
    }
  }

  // Routing for the end of pancreatitis branch.
  if (question.tags.includes(PANCREATITIS_BRANCH_END)) {
    const gallbladderAnswer = findAnswerByTagAndByQuestionTag(
      GALLBLADDER,
      PANCREATITIS_GALLBLADDER,
      answers,
      assessment.questions
    );

    const diabetesAnswer = findAnswerByTagAndByQuestionTag(
      DIABETIC_TYPE_1,
      PANCREATITIS_GALLBLADDER,
      answers,
      assessment.questions
    );

    if (gallbladderAnswer) {
      nextUrlPath = routes.question(
        assessment.questions.find(
          q => q._id === gallbladderAnswer.nextQuestionId
        ).urlPath
      );
    } else if (diabetesAnswer) {
      nextUrlPath = routes.question(
        assessment.questions.find(q => q._id === diabetesAnswer.nextQuestionId)
          .urlPath
      );
    }
  }

  // Routing for showing what opioid frequency
  if (question.tags.includes(MEDICATIONS)) {
    const opioidAnswer = findAnswerByTagAndByQuestionTag(
      OPIOID,
      MEDICATIONS,
      answers,
      assessment.questions
    );

    if (opioidAnswer) {
      nextUrlPath = routes.question(
        assessment.questions.find(q => q._id === opioidAnswer.nextQuestionId)
          .urlPath
      );
    }
  }

  // Mental health routing for Longer eligibility.
  if (question.tags.includes(PHQ2)) {
    const phq1Answer = findAnswerByQuestionTag(
      PHQ1,
      answers,
      assessment.questions
    );
    const phq2Answer = findAnswerByQuestionTag(
      PHQ2,
      answers,
      assessment.questions
    );

    const sumPhq1Phq2 = parseInt(phq1Answer, 10) + parseInt(phq2Answer, 10);
    if (sumPhq1Phq2 < 3) {
      nextUrlPath = routes.question(
        assessment.questions.find(q => q.tags.includes(SUICIDE1)).urlPath
      );
    }
  }

  // Page routing based on BMI.
  if (question.tags.includes(BMI_27_CHECK)) {
    if (profile.bmi < HIGH_BMI) {
      const questionLess27Bmi = assessment.questions.find(q =>
        q.tags.includes(SHOW_IF_BMI_LESS_27)
      );
      nextUrlPath = routes.question(questionLess27Bmi.urlPath);
    }
    if (profile.bmi >= HIGH_BMI && profile.bmi <= OBESE_BMI) {
      const questionBetween27and30Bmi = assessment.questions.find(q =>
        q.tags.includes(SHOW_IF_BMI_BETWEEN_27_AND_30)
      );
      nextUrlPath = routes.question(questionBetween27and30Bmi.urlPath);
    }
    if (profile.bmi > OBESE_BMI) {
      const questionMore30Bmi = assessment.questions.find(q =>
        q.tags.includes(SHOW_IF_BMI_MORE_30)
      );
      nextUrlPath = routes.question(questionMore30Bmi.urlPath);
    }
  }

  // Routing for showing what types of diets user tried
  if (question.tags.includes(DIETING)) {
    const dietingAnswer = findAnswerByTagAndByQuestionTag(
      DIETING,
      DIETING,
      answers,
      assessment.questions
    );
    if (dietingAnswer) {
      nextUrlPath = routes.question(
        assessment.questions.find(q => q._id === dietingAnswer.nextQuestionId)
          .urlPath
      );
    }
  }

  return nextUrlPath;
};
